/* ============================================
   AayuLuxe — Premium Animation Engine
   ============================================ */
(function () {
  'use strict';

  var REVEAL_SEL = '.lx-reveal, .lx-reveal-up, .lx-reveal-left, .lx-reveal-right, .lx-reveal-scale, .lx-reveal-mask, .lx-stagger';

  /* Force everything into its final visible state. Used for reduced-motion,
     for browsers without IntersectionObserver, and by the watchdog below. */
  function revealAll() {
    document.querySelectorAll(REVEAL_SEL).forEach(function (el) {
      el.classList.add('is-visible');
    });
    document.querySelectorAll('[data-lx-split] span > span').forEach(function (s) {
      s.style.transform = 'translateY(0)';
    });
    document.querySelectorAll('[data-lx-img-reveal]').forEach(function (el) {
      el.style.clipPath = 'inset(0 0 0 0)';
    });
    document.querySelectorAll('[data-lx-counter]').forEach(function (el) {
      if (el.getAttribute('data-lx-counted')) return;
      el.setAttribute('data-lx-counted', '1');
      var t = parseInt(el.getAttribute('data-lx-counter'), 10);
      if (!isNaN(t)) {
        el.textContent = (el.getAttribute('data-lx-prefix') || '') +
          t.toLocaleString() + (el.getAttribute('data-lx-suffix') || '');
      }
    });
  }

  /* Watchdog: if anything is still hidden a few seconds in — observer never
     fired, script errored partway, whatever the cause — show it. A missed
     animation is acceptable; invisible copy is not. */
  function startWatchdog() {
    setTimeout(function () {
      var stuck = document.querySelector(REVEAL_SEL + ':not(.is-visible)');
      if (stuck) revealAll();
    }, 3000);
  }

  function init() {
    if (!('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealAll();
      return;
    }

    /* -- Scroll Reveal -- */
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.lx-reveal, .lx-reveal-up, .lx-reveal-left, .lx-reveal-right, .lx-reveal-scale, .lx-reveal-mask, .lx-stagger').forEach(function (el) {
      revealObserver.observe(el);
    });

    /* -- Text Split Reveal -- */
    document.querySelectorAll('[data-lx-split]').forEach(function (el) {
      if (el.getAttribute('data-lx-done')) return;
      el.setAttribute('data-lx-done', '1');
      var text = el.textContent.trim();
      var words = text.split(/\s+/);
      el.innerHTML = '';
      el.style.overflow = 'hidden';

      words.forEach(function (word, i) {
        var wrapper = document.createElement('span');
        wrapper.style.cssText = 'display:inline-block;overflow:hidden;vertical-align:top;padding-bottom:0.08em;';
        var inner = document.createElement('span');
        inner.textContent = word;
        inner.style.cssText = 'display:inline-block;transform:translateY(110%);transition:transform 0.9s cubic-bezier(0.19,1,0.22,1);transition-delay:' + (i * 0.06) + 's;';
        wrapper.appendChild(inner);
        el.appendChild(wrapper);
        if (i < words.length - 1) {
          el.appendChild(document.createTextNode(' '));
        }
      });

      var splitObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var spans = entry.target.querySelectorAll('span > span');
            spans.forEach(function (s) { s.style.transform = 'translateY(0)'; });
            splitObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      splitObserver.observe(el);
    });

    /* -- Parallax -- */
    var parallaxEls = document.querySelectorAll('[data-lx-parallax]');
    if (parallaxEls.length > 0) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            parallaxEls.forEach(function (el) {
              var speed = parseFloat(el.getAttribute('data-lx-parallax')) || 0.12;
              var box = el.parentElement || el;
              var rect = box.getBoundingClientRect();
              if (rect.bottom < 0 || rect.top > window.innerHeight) return;

              /* Progress runs -0.5 (section entering at the bottom) through 0
                 (centred) to +0.5 (leaving at the top). Offset is therefore
                 zero-centred, so the image never slides off its own overhang
                 and expose the section background behind it. */
              var progress =
                (rect.top + rect.height / 2 - window.innerHeight / 2) /
                (window.innerHeight + rect.height);
              var offset = progress * speed * rect.height;
              el.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
            });
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    }

    /* -- Counter Animation -- */
    document.querySelectorAll('[data-lx-counter]').forEach(function (el) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      obs.observe(el);
    });

    function animateCounter(el) {
      var target = parseInt(el.getAttribute('data-lx-counter'), 10);
      var suffix = el.getAttribute('data-lx-suffix') || '';
      var prefix = el.getAttribute('data-lx-prefix') || '';
      var duration = 2200;
      var startTime = null;
      function step(ts) {
        if (!startTime) startTime = ts;
        var p = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 4);
        el.textContent = prefix + Math.floor(eased * target).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = prefix + target.toLocaleString() + suffix;
      }
      requestAnimationFrame(step);
    }

    /* -- Marquee pause on hover -- */
    document.querySelectorAll('.lx-marquee__track').forEach(function (track) {
      track.addEventListener('mouseenter', function () { track.style.animationPlayState = 'paused'; });
      track.addEventListener('mouseleave', function () { track.style.animationPlayState = 'running'; });
    });

    /* -- Magnetic cursor on buttons (desktop only) -- */
    if (window.innerWidth > 1024) {
      document.querySelectorAll('.lx-btn, .lx-btn--text').forEach(function (btn) {
        btn.addEventListener('mousemove', function (e) {
          var rect = btn.getBoundingClientRect();
          var x = (e.clientX - rect.left - rect.width / 2) * 0.15;
          var y = (e.clientY - rect.top - rect.height / 2) * 0.15;
          btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
        });
        btn.addEventListener('mouseleave', function () {
          btn.style.transform = 'translate(0,0)';
          btn.style.transition = 'transform 0.4s cubic-bezier(0.19,1,0.22,1)';
          setTimeout(function () { btn.style.transition = ''; }, 400);
        });
      });
    }

    /* -- Smooth image reveal on scroll -- */
    document.querySelectorAll('[data-lx-img-reveal]').forEach(function (el) {
      el.style.clipPath = 'inset(12% 0 12% 0)';
      el.style.transition = 'clip-path 1.4s cubic-bezier(0.19,1,0.22,1)';
      var imgObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.clipPath = 'inset(0 0 0 0)';
            imgObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });
      imgObs.observe(el);
    });

    startWatchdog();
  }

  function boot() {
    try {
      init();
    } catch (e) {
      /* Never let a scripting error leave the page blank. */
      revealAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
